import { Route, Routes } from 'react-router-dom'

import { RequireAuth } from './context/Authorization/useAuth'

import {
  HomePage,
  BrowsePage,
  SearchPage,
  LoginPage,
  NewGAPurchasePage,
  NewSeatedPurchasePage,
  WaitingRoomPage,
  NewCheckoutPage,
  CheckoutSuccessPage,
  VenuePage,
  OrganizationPage,
  MyEventsPage,
  EventDetailsPage,
  PackageDetailsPage,
  GuestPassDetailsPage,
  AccessPassDetailsPage,
  MyTransfersPage,
  MyListingsPage,
  MyCollectablesPage,
  SettingsPage,
  SettingsOptionsPage,
  PersonalDetailsPage,
  LoginSecurityPage,
  WithdrawInvoicesPage,
  InvoicePage,
  PaymentInformationPage,
  PrivacyPolicyPage,
  TermsConditionsPage,
  PurchasePolicyPage,
  CookiesPolicyPage,
  DisclaimerPage,
  WalletPage,
  ViewPackagePage,
  ViewFlexPackPage,
  ViewAccessPassPage,
  FundraisingCampaignPage,
  GroupManagePage,
  MenuPage,
  SmsTicketsPage,
  WaitlistClaimPage,
  NotFoundPage,
} from './pages'
import { ScrollToTop } from './components'

/**
 * @description Handle all the routes
 */

const Router = () => {
  return (
    <ScrollToTop>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/www" element={<WalletPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route
          path="e/:slug/:shortcode/waiting-room"
          element={<WaitingRoomPage />}
        />
        <Route path="e/:slug/:shortcode" element={<NewGAPurchasePage />} />
        <Route path="group/:groupCode" element={<GroupManagePage />} />
        <Route path="fundraise/:slug" element={<FundraisingCampaignPage />} />
        <Route
          path=":orgSlug/fundraisers/:campaignSlug"
          element={<FundraisingCampaignPage />}
        />
        <Route
          path="menu/:organization_uuid/:venue_uuid/:section_name"
          element={<MenuPage />}
        />
        <Route
          path="menu/:organization_uuid/:section_name"
          element={<MenuPage />}
        />
        <Route
          path="e/:slug/:shortcode/tickets"
          element={<NewSeatedPurchasePage />}
        />
        {/* Unguarded so logged-out fans can check out as guests. */}
        <Route path="waitlist/:token" element={<WaitlistClaimPage />} />
        <Route path="checkout" element={<NewCheckoutPage />} />
        <Route
          path="checkout/checkout-success"
          element={<CheckoutSuccessPage />}
        />
        <Route path="t/:token" element={<SmsTicketsPage />} />
        <Route path="tickets/:token" element={<SmsTicketsPage />} />
        <Route path="venue/:slug" element={<VenuePage />} />
        <Route path="venue/:slug/package/:id" element={<ViewPackagePage />} />
        <Route
          path="venue/:slug/flex-pack/:uuid"
          element={<ViewFlexPackPage />}
        />
        <Route
          path="venue/:slug/access-pass/:uuid"
          element={<ViewAccessPassPage />}
        />
        {['my-events', 'my-events/event-details/:eventUUID'].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <RequireAuth>
                <MyEventsPage />
              </RequireAuth>
            }
          />
        ))}
        <Route
          path="my-packages/:id/package-details/:orderId"
          element={
            <RequireAuth>
              <PackageDetailsPage />
            </RequireAuth>
          }
        />
        {['event-details/:orderId', 'event-details/:orderId/event/:id'].map(
          (path) => (
            <Route
              key={path}
              path={path}
              element={
                <RequireAuth>
                  <EventDetailsPage />
                </RequireAuth>
              }
            />
          )
        )}
        <Route
          path="event-details/:orderId"
          element={
            <RequireAuth>
              <EventDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="guest-passes/:eventUUID"
          element={
            <RequireAuth>
              <GuestPassDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="my-events/access-passes/:uuid"
          element={
            <RequireAuth>
              <AccessPassDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="my-transfers"
          element={
            <RequireAuth>
              <MyTransfersPage />
            </RequireAuth>
          }
        />
        <Route
          path="my-listings"
          element={
            <RequireAuth>
              <MyListingsPage />
            </RequireAuth>
          }
        />
        <Route path="my-collectables" element={<MyCollectablesPage />} />
        <Route
          path="settings"
          element={
            <RequireAuth>
              <SettingsPage />
            </RequireAuth>
          }
        >
          <Route index element={<SettingsOptionsPage />} />
          <Route path="personal-details" element={<PersonalDetailsPage />} />
          <Route path="login-security" element={<LoginSecurityPage />} />
          <Route path="withdraw-invoices" element={<WithdrawInvoicesPage />} />
          <Route
            path="withdraw-invoices/invoice/:id"
            element={<InvoicePage />}
          />
          <Route
            path="payment-information"
            element={<PaymentInformationPage />}
          />
        </Route>
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="terms-conditions" element={<TermsConditionsPage />} />
        <Route path="purchase-policy" element={<PurchasePolicyPage />} />
        <Route path="cookies-policy" element={<CookiesPolicyPage />} />
        <Route path="disclaimer" element={<DisclaimerPage />} />
        <Route path=":slug/package/:id" element={<ViewPackagePage />} />
        <Route path=":slug/flex-pack/:uuid" element={<ViewFlexPackPage />} />
        <Route path=":slug" element={<OrganizationPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ScrollToTop>
  )
}

export default Router
